import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-row justify-content-center"
}
const _hoisted_2 = { class: "border rounded bg-white px-3 py-3" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Имя")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Укажите имя клиенра ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Фамилия")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Укажите фамилию клиенра ")
const _hoisted_7 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "mt-4 mb-5" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Сохранить ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CSpinner = _resolveComponent("CSpinner")!
  const _component_CFormLabel = _resolveComponent("CFormLabel")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_CFormFeedback = _resolveComponent("CFormFeedback")!
  const _component_CCol = _resolveComponent("CCol")!
  const _component_CRow = _resolveComponent("CRow")!
  const _component_CFormSwitch = _resolveComponent("CFormSwitch")!
  const _component_CIcon = _resolveComponent("CIcon")!
  const _component_CAlert = _resolveComponent("CAlert")!
  const _component_CButton = _resolveComponent("CButton")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_CSpinner)
      ]))
    : (_openBlock(), _createElementBlock("form", {
        key: 1,
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveCleaner && _ctx.saveCleaner(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_CRow, null, {
            default: _withCtx(() => [
              _createVNode(_component_CCol, { md: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_CFormLabel, null, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_AppInput, {
                    type: "text",
                    invalid: _ctx.cleaner.firstNameInvalid,
                    onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cleaner.firstNameInvalid = false)),
                    modelValue: _ctx.cleaner.firstName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.cleaner.firstName) = $event))
                  }, null, 8, ["invalid", "modelValue"]),
                  _createVNode(_component_CFormFeedback, { invalid: "" }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_CCol, { md: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_component_CFormLabel, null, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_AppInput, {
                    type: "text",
                    invalid: _ctx.cleaner.lastNameInvalid,
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cleaner.lastNameInvalid = false)),
                    modelValue: _ctx.cleaner.lastName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cleaner.lastName) = $event))
                  }, null, 8, ["invalid", "modelValue"]),
                  _createVNode(_component_CFormFeedback, { invalid: "" }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.cleaner.id !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_CFormSwitch, {
                  label: "Уволен",
                  id: "cleanerIsFiredSwitch",
                  onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cleaner.isFired = $event.target.checked)),
                  checked: _ctx.cleaner.isFired,
                  size: "lg"
                }, null, 8, ["checked"])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.validationErrors !== null)
          ? (_openBlock(), _createBlock(_component_CAlert, {
              key: 0,
              color: "danger",
              class: "d-flex align-items-center mt-5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CIcon, {
                  icon: "cil-burn",
                  class: "flex-shrink-0 me-4",
                  width: "24",
                  height: "24"
                }),
                _createElementVNode("div", {
                  innerHTML: _ctx.validationErrors.innerHTML
                }, null, 8, _hoisted_8)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_CButton, {
            type: "submit",
            color: "primary",
            disabled: _ctx.savingLoading
          }, {
            default: _withCtx(() => [
              (_ctx.savingLoading)
                ? (_openBlock(), _createBlock(_component_CSpinner, {
                    key: 0,
                    size: "sm",
                    class: "me-2"
                  }))
                : (_openBlock(), _createBlock(_component_CIcon, {
                    key: 1,
                    icon: "cil-save",
                    class: "me-2"
                  })),
              _hoisted_10
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 32))
}